import { FILTER_STATUS_SOURCING_PROJECTS } from './constants'

export const filterStatusSourcingProjects = (status = 0, event = null) => ({
  type: FILTER_STATUS_SOURCING_PROJECTS,
  status,
  event,
})
